import Vue from 'vue';
import gaService from './ga.service';

export default {
  async openSession(gameId, language, isMobile, backUrl, showBalance) {
    gaService.send('games', 'hdraces', gameId);
    return (await Vue.http.post('/api/hdraces/session/open', { gameId, language, isMobile, backUrl, showBalance })).data;
  },
  async openDemoSession(gameId, language, isMobile, backUrl, showBalance) {
    gaService.send('games-demo', 'hdraces', gameId);
    return (await Vue.http.post('/api/hdraces/session/opendemo', { gameId, language, isMobile, backUrl, showBalance })).data;
  },
  async closeSession() {
    return (await Vue.http.post('/api/hdraces/session/close')).data;
  },
  async getHdRacesTicket(hdRacesTicketId) {
    return (await Vue.http.get(`/api/hdraces/tickets/${hdRacesTicketId}`)).data;
  },
  async getHdRacesTickets(balanceId, date, take, skip, statuses) {
    return (await Vue.http.post('/api/hdraces/tickets', { balanceId, date, take, skip, statuses })).data;
  }
}



// WEBPACK FOOTER //
// ./_common/services/hdraces.service.js